module.exports = __webpack_public_path__ + "static/media/15-3.68f2dfd5.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/15-3.PNG
// module id = 216
// module chunks = 0